<script lang="ts" setup>
    import DesktopNav from "./DesktopNav.vue";
    import MobileNav from "./MobileNav.vue";

    const props = defineProps<{
        page: any
    }>();

</script>
<template>
    <DesktopNav :page="page" />
    <MobileNav :page="page" />
</template>
